import { CHECKOUT_SESSION_TOKEN_ACTIONS } from './checkoutSessionToken.types'

/**
 * @param {import('./checkoutSessionToken.types').CheckoutSessionTokenSlice['status']} payload
 * @returns {import('./checkoutSessionToken.types').SetStatusAction}
 */
export const setCheckoutSessionTokenStatusAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./checkoutSessionToken.types').SetErrorsAction}
 */
export const setCheckoutSessionTokenErrorsAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @param {string} payload - The full token string
 * @returns {import('./checkoutSessionToken.types').SetTokenAction}
 */
export const setTokenAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_TOKEN,
  payload
})

/**
 * @param {string} payload - The short code for display
 * @returns {import('./checkoutSessionToken.types').SetShortCodeAction}
 */
export const setShortCodeAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_SHORT_CODE,
  payload
})

/**
 * @param {import('./checkoutSessionToken.types').MultiAddressSelectionItem[]} payload
 * @returns {import('./checkoutSessionToken.types').SetMultiAddressSelectionAction}
 */
export const setMultiAddressSelectionAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_MULTI_ADDRESS_SELECTION,
  payload
})

/**
 * @param {Object} payload - Selected billing address object
 */
export const setSelectedBillingAddressAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_SELECTED_BILLING_ADDRESS,
  payload
})

/**
 * @param {number} payload - Selected customer address ID (for logged-in single-address checkout)
 * @returns {import('./checkoutSessionToken.types').SetSelectedCustomerAddressIdAction}
 */
export const setSelectedCustomerAddressIdAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_SELECTED_CUSTOMER_ADDRESS_ID,
  payload
})

/**
 * @param {import('./checkoutSessionToken.types').GuestCheckoutData} payload
 */
export const setGuestCheckoutDataAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_GUEST_CHECKOUT_DATA,
  payload
})

/**
 * @param {import('./checkoutSessionToken.types').PaymentStatus} payload
 * @returns {import('./checkoutSessionToken.types').SetPaymentStatusAction}
 */
export const setPaymentStatusAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_PAYMENT_STATUS,
  payload
})

/**
 * @param {boolean} payload
 * @returns {import('./checkoutSessionToken.types').SetUsedAction}
 */
export const setUsedAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_USED,
  payload
})

/**
 * Set multiple token data fields at once
 * @param {Partial<import('./checkoutSessionToken.types').CheckoutSessionTokenState>} payload
 * @returns {import('./checkoutSessionToken.types').SetTokenDataAction}
 */
export const setTokenDataAction = payload => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.SET_TOKEN_DATA,
  payload
})

/**
 * @returns {import('./checkoutSessionToken.types').ClearAction}
 */
export const clearCheckoutSessionTokenErrorsAction = () => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.CLEAR_ERRORS
})

/**
 * @returns {import('./checkoutSessionToken.types').ClearAction}
 */
export const clearCheckoutSessionTokenAction = () => ({
  type: CHECKOUT_SESSION_TOKEN_ACTIONS.CLEAR_TOKEN
})
